import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UsersSearchDto } from '../../../../models/partnerAccounts/users/users-searchDto';
import { UrlConstants } from '../../../../constants/url.constants';
import { PartnerUser } from '../../../../models/partnerAccounts/users/partner-user';

@Injectable({
  providedIn: "root",
})
export class PartnersUsersService {

  readonly http = inject(HttpClient);
  userDtls :UsersSearchDto=new UsersSearchDto();

getUserData(){
  return this.userDtls;
}
  setUserData(user:UsersSearchDto){
     this.userDtls=user;
  }

   getUsersDtls=()=> this.http.get<UsersSearchDto> (UrlConstants.PARTNERS_USERS_URL);
   searchUsersDtls=(user:UsersSearchDto)=> this.http.post<PartnerUser[]> (UrlConstants.PARTNERS_SEARCH_USERS_URL,user);
   saveUser=(user:PartnerUser)=>this.http.post<string[]>(UrlConstants.PARTNERS_SEARCH_USERS_SAVE_URL,user);

}
